import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { useId } from 'react';
import { cn } from '../../shared/cn';
import './loading-spinner.css';
type LoaderSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'button';
type LoaderProps = {
  size?: LoaderSize;
  className?: string;
};
const sizeMap: Record<LoaderSize, string> = {
  xs: 'w-6 h-6',
  sm: 'w-7 h-7',
  base: 'w-8 h-8',
  lg: 'w-9 h-9',
  xl: 'w-10 h-10',
  button: 'w-5 h-5'
};
export const LoadingSpinner: FC<LoaderProps> = t0 => {
  const $ = _c(26);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "base" : t1;
  const t2 = useId();
  let t3;
  if ($[0] !== t2) {
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = /:/g;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    t3 = t2.replace(t4, "");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const id = t3;
  const leadingGradientId = `${id}-leading`;
  const trailingGradientId = `${id}-trailing`;
  const t4 = sizeMap[size];
  let t5;
  if ($[3] !== className || $[4] !== t4) {
    t5 = cn("loading-spinner inline-block", t4, className);
    $[3] = className;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <stop offset="0%" stopColor="currentColor" />;
    t7 = <stop offset="100%" stopColor="currentColor" stopOpacity="0.55" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== leadingGradientId) {
    t8 = <linearGradient id={leadingGradientId} x1="50%" x2="50%" y1="5.271%" y2="91.793%">{t6}{t7}</linearGradient>;
    $[8] = leadingGradientId;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t10;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <stop offset="0%" stopColor="currentColor" stopOpacity="0" />;
    t10 = <stop offset="100%" stopColor="currentColor" stopOpacity="0.55" />;
    $[10] = t10;
    $[11] = t9;
  } else {
    t10 = $[10];
    t9 = $[11];
  }
  let t11;
  if ($[12] !== trailingGradientId) {
    t11 = <linearGradient id={trailingGradientId} x1="50%" x2="50%" y1="15.24%" y2="87.15%">{t9}{t10}</linearGradient>;
    $[12] = trailingGradientId;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t8) {
    t12 = <defs>{t8}{t11}</defs>;
    $[14] = t11;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `url(#${leadingGradientId})`;
  let t14;
  if ($[17] !== t13) {
    t14 = <path d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.5 7.5 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021" fill={t13} transform="translate(1.5 1.625)" />;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = `url(#${trailingGradientId})`;
  let t16;
  if ($[19] !== t15) {
    t16 = <path d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.48 10.48 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118" fill={t15} transform="translate(1.5 1.625)" />;
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t12 || $[22] !== t14 || $[23] !== t16 || $[24] !== t5) {
    t17 = <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="status" aria-label="Loading" className={t5}>{t12}{t14}{t16}</svg>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t16;
    $[24] = t5;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  return t17;
};